import { FC, ReactNode, useContext } from 'react';

import { RolesAndPermissionContext } from '@/contexts';

type Props = {
  to: string[];
  fallback?: ReactNode;
  children: ReactNode;
};

export const Restricted: FC<Props> = ({ to, fallback, children }) => {
  const { isAllowedTo } = useContext(RolesAndPermissionContext);

  if (isAllowedTo(to)) {
    return <>{children}</>;
  }

  return fallback ? <>{fallback}</> : null;
};
